<ng-container *ngIf="assigneesIdMap && assigneeIds">
  <ui-assignee-avatar
    *ngFor="let assigneeId of assigneeIds.slice(0, sliceAvatarsUntilIndex); let i = index"
    class="ui-group-assignee"
    [style.z-index]="i"
    [uiAssignee]="assigneesIdMap[assigneeId]"
    [uiSize]="size"
    [uiShowTooltip]="true"></ui-assignee-avatar>

  <div *ngIf="assigneeIds.length - max > 0" class="ui-group-assignee" [style.z-index]="assigneeIds.length + 1" ui-tooltip [uiTooltipTitle]="avatarGroupTooltipTemplate" uiTooltipPlacement="bottom">
    <div class="ui-more-assignees-number">+{{ assigneeIds.length - sliceAvatarsUntilIndex }}</div>
  </div>
</ng-container>

<ng-template #avatarGroupTooltipTemplate>
  <div class="ui-assignee-avatar-group-tooltip-wrapper" *ngIf="assigneesIdMap && assigneeIds">
    <ui-assignee *ngFor="let assigneeId of assigneeIds.slice(sliceAvatarsUntilIndex)" [uiAssignee]="assigneesIdMap[assigneeId]" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
  </div>
</ng-template>
